export default __webpack_public_path__ + "static/media/element_28.df6a0fb3.jpg";